import flow from 'lodash/flow';
import connectAsync from '../../utils/connectAsync';
import withAdScreenRequest from '../../decorators/ads/withAdScreenRequest';
import withLotameTargeting from '../../decorators/ads/withLotameTargeting';
import fetchCategory from '../../utils/connectors/fetchCategory';

// e.g: /podcasts/, /audiobooks/
import { createRootCategoryContext } from '../../routes/utils/getBrowseContext';
import BrowseLoader from './BrowseLoader';

export default flow(
  withAdScreenRequest(() => 'browse'),
  withLotameTargeting,
  connectAsync([fetchCategory(createRootCategoryContext)]),
)(BrowseLoader);
